<template>
  <div>
    <b-alert
      v-if="!parvandehCode"
      show
      variant="danger"
      class="font-weight-bold"
    >
      <i class="fas fa-info-circle fa-lg mr-2" />
      <span v-text="noParvandehCodeMessage" />
    </b-alert>
    <TwoStepWrapper
      v-else
      :parentLoading="loading"
      :parentShowLoadingText="true"
      :registered="isCanceled"
      :validSendCode="!isCanceled && !loading && !!cancelDescription"
      :submitted="submitted"
      :licenceText="licenceText"
      alertVariant="danger"
      :confirmLoadingSpinnerText="$lang.updating_data"
      @setData="setParvandeh"
      @updateAccept="updateAccept"
    >
      <template slot="header">
        <b-row v-if="!loading">
          <b-col
            cols="12"
            class="d-flex align-items-center fs_16 border-bottom pb-2 mb-3 w-100"
          >
            <i class="fas fa-user-times fa-lg mr-2" />
            <b v-text="$lang.request_to_cancel_parvandeh" />
          </b-col>
          <b-col v-if="!loading" cols="12" md="12" class="lh_30 mb-3 w-100">
            <div v-html="alertText" />
            <div class="text-right" v-if="!continueLevel && !isCanceled">
              <b-button variant="primary" @click="continueLevel = true">
                {{ $lang.continue }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </template>
      <template slot="body">
        <b-row v-if="!Object.keys(parvandehData).length" class="mx-0">
          <b-col>
            <LoadingSpinner :loading="loading" />
            <b-alert class="text-center" :show="errorMessage" variant="info">
              {{ errorMessage }}
            </b-alert>
          </b-col>
        </b-row>

        <b-row
          v-if="
            Object.keys(parvandehData).length && !isCanceled && continueLevel
          "
          class="mx-0 mb-3"
        >
          <b-col>
            <label v-text="'علت انصراف از پرونده:'" />
            <b-textarea
              v-model="cancelDescription"
              placeholder="علت انصراف خود را بنویسید"
            />
          </b-col>
        </b-row>
        <div class="w-100 overflow-x-auto">
          <b-row
            v-if="Object.keys(parvandehData).length && isCanceled"
            class="mx-0 rounded p-md-5 pt-5 pb-5 bg-white text-dark"
            id="section-to-print"
            style="width: 595px; height: 842px"
          >
            <b-col cols="4" md="auto" class="">
              <b-img fluid :src="$config.images.tinyLogo" width="70" />
            </b-col>
            <b-col cols="4" md="" class="text-center">
              <b-img fluid :src="$config.images.shared.besme" width="70" />
            </b-col>
            <b-col cols="4" md="auto" class="text-justify fs_12">
              <div
                v-text="
                  `شماره پیگیری: ${pathOr(
                    '',
                    ['parvandeh', 'parvandeh_number'],
                    this.parvandehData
                  )}`
                "
              />
              <div
                v-text="
                  `تاریخ: ${pathOr(
                    '',
                    ['parvandeh', 'cancel_at', 'jalali'],
                    this.parvandehData
                  )}`
                "
              />
              <div v-text="'پیوست: ندارد'" />
            </b-col>
            <b-col
              cols="12"
              md="12"
              class="mt-4 mb-5 lh_45"
              v-html="laterText"
            />
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-end mt-5"
            >
              <div class="text-center w-50 mt-5">
                <small v-text="bossName" /><br />
                <small v-text="bossType" /><br />
                <div
                  class="position-relative d-flex align-items-center justify-content-center top_less_160 mr-3"
                >
                  <b-img
                    fluid
                    :src="bossSignatureAndSeal.signature"
                    width="90"
                  />

                  <b-img fluid :src="bossSignatureAndSeal.seal" width="120" />
                </div>
              </div>
              <div></div>
            </b-col>
          </b-row>
        </div>
        <b-row
          v-if="Object.keys(parvandehData).length && isCanceled"
          class="mx-0 rounded bg-white text-dark border-top mt-0"
          style="width: 595px"
        >
          <b-col class="text-center py-3">
            <b-button class="m-1" variant="primary" @click="print">
              <i class="fas fa-download mr-2" />
              <strong v-text="$lang.getPdfVersion" />
            </b-button>
          </b-col>
        </b-row>
      </template>
    </TwoStepWrapper>
  </div>
</template>
<script>
import TwoStepWrapper from "@/components/base/TwoStepWrapper";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { checkActiveParvandeh, generateApiUrl } from "@/shared/utils";
import { pathOr } from "ramda";
import { mapActions } from "vuex";

export default {
  components: {
    TwoStepWrapper,
    LoadingSpinner,
  },
  data() {
    return {
      continueLevel: false,
      accept: false,
      loading: false,
      registered: false,
      submitted: false,
      isCanceled: false,
      activeParvandehData: {},
      parvandehData: {},
      cancelDescription: "",
      noParvandehCodeMessage: `این صفحه فقط برای کاربرانی قابل مشاهده است که دارای پرونده هستند با توجه به اینکه شما پرونده فعالی ندارید امکان مشاهده این صفحه را ندارید.`,
      errorMessage: null,
    };
  },
  computed: {
    alertText() {
      const fullName =
        pathOr("", ["person", "name"], this.parvandehData) +
        " " +
        pathOr("", ["person", "family"], this.parvandehData);
      const fatherName = pathOr(
        "",
        ["person", "father_name"],
        this.parvandehData
      );
      const birthDate = pathOr(
        "",
        ["person", "birth_date", "jalali"],
        this.parvandehData
      );
      const nationalCode = pathOr(
        "",
        ["person", "national_code"],
        this.parvandehData
      );
      const license = pathOr(
        "",
        ["parvandeh", "license", "caption"],
        this.parvandehData
      );
      const term = pathOr(
        "",
        ["parvandeh", "term", "caption"],
        this.parvandehData
      );
      const canceledAt = pathOr(
        "",
        ["parvandeh", "cancel_at", "jalali"],
        this.parvandehData
      );
      const cancelDescription = pathOr(
        "",
        ["parvandeh", "cancel_description"],
        this.parvandehData
      );
      const parvandehNumber = pathOr(
        "",
        ["parvandeh", "parvandeh_number"],
        this.parvandehData
      );
      const stepOneText = `<p class="fs_12">پرونده شماره <b class="text-primary">${parvandehNumber}</b> شما در حال حاضر فعال است بازکردن این فرم (فرم انصراف) و مشاهده این متن به منزله انصراف از ادامه پرونده نمی باشد ولی در صورتی که به هر دلیل از ادامه فرایند این پرونده منصرف شده اید و می خواهید پرونده جاری خود را قبل از طی مراحل قانونی خاتمه دهید لطفا دکمه "ادامه" را انتخاب و مراحل پیش رو را انجام دهید.
      </p>
      <i class="fas fa-info-circle mr-1 text-primary"></i>
      <span class="text-primary fs_12">مقتضی است بعد از تکمیل فرایند انصراف، گواهی انصراف برای شما قابل رویت و چاپ خواهد بود.</span>`;
      const stepTwoText = `<p class="fs_12">اینجانب ${fullName} فرزند ${fatherName} متولد ${birthDate} به شماره ملی ${nationalCode} پذیرفته شده در آزمون ${license} دوره ${term} انصراف قطعی خود از ادامه فرایند جذب مرکز را اعلام داشته  و مطلع هستم که به هیچ عنوان امکان بازگشت مجدد و ثبت‌نام را نخواهم داشت.</p>
       <i class="fas fa-info-circle mr-1 text-danger"></i>
      <span class="text-danger fs_12"> مقتضی است در صورت تایید انصراف هیچ گونه حقی مبنی بر بازگشت مبالغ پرداختی طی مراحل ثبت نام و بازگشایی مجدد پرونده برای من وجود نخواهد داشت.</span>`;
      const text = this.continueLevel ? stepTwoText : stepOneText;
      const canceledText = `<p>با توجه به انصراف شما درتاریخ  <b class="text-primary">${canceledAt}</b> بعلت <b class="text-primary">${cancelDescription}</b> و بسته شدن پرونده شماره <b class="text-primary">${parvandehNumber}</b> امکان انصراف مجدد نمی باشد شما می توانید گواهی انصراف خود را در فرم ذیل مشاهده و دانلود نمائید.</p>`;
      return this.isCanceled ? canceledText : text;
    },
    laterText() {
      const fullName =
        pathOr("", ["person", "name"], this.parvandehData) +
        " " +
        pathOr("", ["person", "family"], this.parvandehData);
      const nationalCode = pathOr(
        "",
        ["person", "national_code"],
        this.parvandehData
      );
      let gender = pathOr(
        "",
        ["person", "gender", "caption"],
        this.parvandehData
      );
      gender = gender === "آقا" ? "آقای" : gender;
      const license = pathOr(
        "",
        ["parvandeh", "license", "caption"],
        this.parvandehData
      );
      const text = `<b>گواهی انصراف از فرایند جذب</b><br>
        <p class="fs_12 text-justify">بدین‌وسیله گواهی می‌شود  ${fullName} با کد ملی ${nationalCode} از درخواست خود برای دریافت پروانه کارآموزی ${license} انصراف داده است لذا این گواهی به درخواست نامبرده صادر می‌گردد.
        <br>لازم به ذکر است این گواهی به صورت الکترونیک و از طریق سامانه جذب مرکز وکلا، کارشناسان رسمی و مشاوران خانواده قوه قضاییه با توجه به ثبت درخواست قطعی نامبرده صادر شده است.</p>`;

      return text;
    },
    licenceText() {
      const parvandehNumber = pathOr(
        "",
        ["parvandeh", "parvandeh_number"],
        this.parvandehData
      );
      const text = `با در نظر گرفتن کلیه شرایط گفته شده فرایند انصراف را تایید می نمایم و درخواست بسته شدن پرونده شماره <b class="text-primary">${parvandehNumber}</b> خود را دارم.`;
      return text;
    },
    parvandehCode() {
      return pathOr(null, ["code"], this.activeParvandehData);
    },
    bossName() {
      const license = pathOr(
        "",
        ["parvandeh", "license", "id"],
        this.parvandehData
      );
      const types = {
        1: "یوسف رضا ادیب زاده",
        2: "شاهپور کلانتری",
        3: "محسن ابراهیمی",
      };
      return pathOr("", [license], types);
    },
    bossType() {
      const license = pathOr(
        "",
        ["parvandeh", "license", "id"],
        this.parvandehData
      );
      const types = {
        1: "معاون وکلا",
        2: "معاونت کارشناسان رسمی",
        3: "معاون مشاوران خانواده",
      };
      return pathOr("", [license], types);
    },
    bossSignatureAndSeal() {
      const license = pathOr(
        "",
        ["parvandeh", "license", "id"],
        this.parvandehData
      );
      const types = {
        1: {
          signature: this.$config.images.shared.vekalatSignature,
          seal: this.$config.images.shared.vekalatSeal,
        },
        2: {
          signature: this.$config.images.shared.karshenasanSignature,
          seal: this.$config.images.shared.karshenasanSeal,
        },
        3: { signature: "", seal: "" },
      };
      const defaultObj = { signature: "", seal: "" };
      return pathOr(defaultObj, [license], types);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["getMenu"]),
    pathOr,
    checkActiveParvandeh,
    generateApiUrl,
    print() {
      window.print();
    },
    updateAccept(value) {
      this.accept = value;
    },
    async getParvandeh() {
      try {
        this.loading = true;
        let url = this.$config.api_url + this.$config.profile.parvandeh_cancel;
        const response = await this.$httpService.get(url);
        this.parvandehData = {
          ...pathOr(null, ["data", "data"], response),
        };
        this.isCanceled = !!pathOr(
          false,
          ["parvandeh", "cancel_at"],
          this.parvandehData
        );
        this.registered = !!(this.parvandehData && this.isCanceled);
      } catch (error) {
        this.errorMessage = pathOr("", ["response", "data", "message"], error);
        this.$generateError(error);
      } finally {
        this.submitted = false;
        this.loading = false;
      }
    },
    async setParvandeh(params) {
      try {
        this.loading = true;
        const { two_step_code, control_code } = params;
        const payload = {
          control_code,
          two_step_code,
          cancel_description: this.cancelDescription,
        };
        const url = generateApiUrl(["profile", "parvandeh_cancel"]);
        const response = await this.$httpService.patch(url, payload);
        this.submitted = true;
        await this.getParvandeh();
        this.$notify.success(response.data.message);
        await this.getMenu();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchData() {
      this.activeParvandehData = {
        ...checkActiveParvandeh(),
      };
      if (!this.parvandehCode) {
        return;
      }
      this.getParvandeh();
    },
  },
};
</script>

<style scoped>
.widthheight {
  width: 80px;
  height: 80px;
}

.top_less_150 {
  top: -150px;
}
.top_less_160 {
  top: -160px;
}
</style>
